import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Patient } from 'app/core/models/patient.model';
import { NavigationService, PageChangeEvent } from 'app/core/services/navigation.service';
import { PatientService } from 'app/core/services/patient.service';

import { PatientHeaderComponent } from '../../components/patient-header/patient-header.component';
import { NotesForModelComponent } from '../../../shared/components/notes-for-model/notes-for-model.component';
import { PatientDemographicsComponent } from '../../components/patient-demographics/patient-demographics.component';
import { PatientGroupedPatientsComponent } from '../../components/patient-grouped-patients/patient-grouped-patients.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-patient',
    templateUrl: './capture-admin-patient.component.html',
    styleUrls: ['./capture-admin-patient.component.scss'],
    imports: [PatientHeaderComponent,
              NotesForModelComponent,
              PatientDemographicsComponent,
              PatientGroupedPatientsComponent,
              MatProgressSpinner]
})
export class CaptureAdminPatientComponent implements OnInit {
  private patientService = inject(PatientService);
  private route = inject(ActivatedRoute);
  private navigationService = inject(NavigationService);

  patient: Patient;
  loading: boolean;
  currentSection = 'patientDetails';

  constructor() {
    this.navigationService.pageChanged.subscribe((_pageChangeEvent: PageChangeEvent) => {
      this.init();
    });
  }

  ngOnInit() {
    this.init();
  }

  private init() {
    const patientId = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    this.loading = true;

    this.patientService.get(patientId).subscribe(patient => {
      this.patient = patient;
      this.loading = false;
    });
  }
}
